/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './toolbar.tpl.html';

angular
  .module('receipts.toolbar', [])
  /**
   * Controller for the receipts.toolbar template.
   */
  .controller('ReceiptsToolbarCtrl', function ($scope, extraInfo, $state, VIEW_STATES) {
    $scope.extraInfo = angular.copy(extraInfo);
    $scope.VIEW_STATES = VIEW_STATES;

    /**
     * Handler method for the print button.
     */
    $scope.doPrint = function () {
      //TODO: do what needs doing
    };

    /**
     * Handler for the toolbar label.  It is only used in the receipt state to return to the list state.
     */
    $scope.receiptNav = function () {
      if ($scope.state.current.name === VIEW_STATES.RECEIPTS_CONTENT_RECEIPT) {
        $state.go(VIEW_STATES.RECEIPTS_CONTENT_LIST);
      }
    };

    /**
     * Function to refresh the current view.
     */
    $scope.updateView = function () {
      $state.go($state.current, {}, { reload: true });
    };

    /**
     * Function to go back to settings.
     */
    $scope.goBack = function () {
      $state.go(VIEW_STATES.ACCOUNT);
    };
  });
